import { render, staticRenderFns } from "./CustomerPhoneEmail.vue?vue&type=template&id=c6ac36da"
import script from "./CustomerPhoneEmail.vue?vue&type=script&lang=js"
export * from "./CustomerPhoneEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6ac36da')) {
      api.createRecord('c6ac36da', component.options)
    } else {
      api.reload('c6ac36da', component.options)
    }
    module.hot.accept("./CustomerPhoneEmail.vue?vue&type=template&id=c6ac36da", function () {
      api.rerender('c6ac36da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerPhoneEmail.vue"
export default component.exports